import { ConfigurationState } from 'redux/reducers/initialState'

import { IRootState } from '../redux/reducers'

import { store } from './../redux/configureStore'
import { Configuration } from './kmsapiclient'

export const xKMSClient = 'SureAdminConsole'

/**
 * Retrieves the configuration object asynchronously.
 *
 * @returns {Configuration} The configuration object.
 */
export const getConfigurationAsync = (
  includeAccessToken = true,
): Configuration => {
  const state: IRootState = store.getState()
  const configuration: ConfigurationState | null = state.configuration
  const baseOptions = {
    headers: {
      'X-KMS-Client': xKMSClient,
    },
  }
  return new Configuration({
    basePath: configuration?.kmsApiUrl || '',
    accessToken: includeAccessToken ? getAccessToken() : '',
    baseOptions,
  })
}

export const getAccessToken = (): string => {
  const state = store.getState()
  const accessToken = state.identity && state.identity.accessToken
  const tokenExpired =
    state.identity?.tokenExpiry == null ||
    state.identity.tokenExpiry < new Date()

  if (!accessToken) {
    throw new Error('Please Sign In')
  }

  if (tokenExpired) {
    setTimeout(function () {
      location.reload()
    }, 3000)
    throw new Error('Session Expired')
  }

  return accessToken
}
